import React from 'react';
import {
  Alert,
  Button,
  Form,
  FormBody,
  FormFooter,
  Modal,
  ModalContent,
  ModalHeader,
  ModalSection,
  Title,
} from '@zen-common/components-base';
import { assetUtils } from '@zen/common-utils';
import { NamingAssetStore, FpUtils } from '@zen/common-app-parts';
import { Decimal } from 'decimal.js';
import { VerifyEventStore } from '../../stores/FixedPayoutStore';
import AssetFG from '../../components/form/result/AssetFG';
import useContract from '../../hooks/useContract';

export default function VerifyEventResult({ hide }) {
  const { state: naming } = NamingAssetStore.useStore();
  const store = VerifyEventStore.useStore();
  const oracleContractId = (store.state.oracle || {}).contractId;
  const oraclePubKey = (store.state.oracle || {}).publicKey;
  const { id: fpContractId } = useContract();

  const positionAssets = FpUtils.getPositionsAssetId({
    start: store.state.date.value.valueOf().toString(),
    expiry: store.state.date.value.valueOf().toString(),
    asset: assetUtils.getAssetFullId(store.state.collateralAsset.value),
    fpContractId: fpContractId,
    contractId: oracleContractId,
    publicKey: oraclePubKey,
    price: new Decimal(store.state.price.value.safeValue).times(100).toString(),
    ticker: store.state.ticker.value,
  });

  return naming[positionAssets.bear] ? (
    <>
      <Modal>
        <ModalContent large>
          <ModalHeader>{<Title>The assets generated by the contract are:</Title>}</ModalHeader>
          <ModalSection>
            <Form>
              <FormBody>
                <>
                  <AssetFG
                    label={FpUtils.getTitle({ asset: positionAssets.bull, title: 'Bull', naming })}
                    value={positionAssets.bull}
                    readOnly
                  />
                  <AssetFG
                    label={FpUtils.getTitle({ asset: positionAssets.bear, title: 'Bear', naming })}
                    value={positionAssets.bear}
                    readOnly
                  />
                </>
              </FormBody>
              <FormFooter>
                <Button type="submit" onClick={hide}>
                  Close
                </Button>
              </FormFooter>
            </Form>
          </ModalSection>
        </ModalContent>
      </Modal>
    </>
  ) : (
    <>
      <Alert type={Alert.TYPE.ERROR} onDismiss={hide} title="Could not verify">
        The event was never used to issue a token
      </Alert>
    </>
  );
}
